import { boolean, object, optional, string } from "valibot";

export const CampaignInputSchema = object({
  atMedium: optional(string()),
  atCampaign: optional(string()),
  atType: optional(string()),
  atIdentifier: optional(string()),
  atFormat: optional(string()),
  atCreation: optional(string()),
  atVariant: optional(string()),
  utmSource: optional(string()),
  atOperationId: optional(string()),
  referer: string(),
  fbclid: optional(string()),
  gclid: optional(string()),
});

export const CampaignOutputSchema = object({
  success: boolean(),
});

export type CampaignInputSchema = typeof CampaignInputSchema;
export type CampaignOutputSchema = typeof CampaignOutputSchema;
